module.exports = __webpack_public_path__ + "img/img-96eb79.png";